// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Apple';

export function Apple() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
    >
      <title>{TITLE}</title>
      <path
        d="M12.3789 6.61539C13.2816 6.61539 14.4132 6.00509 15.0871 5.19135C15.6974 4.45391 16.1424 3.42403 16.1424 2.39415C16.1424 2.25429 16.1297 2.11443 16.1043 2C15.0998 2.03814 13.8919 2.67387 13.1672 3.52575C12.595 4.17419 12.0737 5.19135 12.0737 6.23395C12.0737 6.38652 12.0992 6.5391 12.1119 6.58996C12.1755 6.60267 12.2772 6.61539 12.3789 6.61539Z"
        fill="currentColor"
      />
      <path
        d="M9.20025 22C10.4336 22 10.9803 21.1736 12.5188 21.1736C14.0826 21.1736 14.4259 21.9746 15.7991 21.9746C17.1469 21.9746 18.0496 20.7286 18.9015 19.508C19.8551 18.1094 20.2492 16.7362 20.2746 16.6726C20.1856 16.6472 17.6046 15.5919 17.6046 12.6294C17.6046 10.061 19.6389 8.90401 19.7533 8.81501C18.4056 6.8824 16.3585 6.83154 15.7991 6.83154C14.2861 6.83154 13.0528 7.74699 12.2772 7.74699C11.438 7.74699 10.3318 6.8824 9.02225 6.8824C6.5302 6.8824 4 8.94216 4 12.8328C4 15.2486 4.94088 17.8042 6.0979 19.4571C7.08964 20.8557 7.95423 22 9.20025 22Z"
        fill="currentColor"
      />
    </svg>
  );
}
